
import finance from './finance' // 财务

const extendRouter = [
  finance,
]

export default extendRouter
